import apiCall from "../../axios";
import queryString from "query-string";

const getCameras = async (opts: any = null) => {
  try {
    const stringified = queryString.stringify(opts);
    let tail = `cameras/v2`;
    if (opts) tail += `?${stringified}`;
    const res = await apiCall("GET", tail);
    return res.data;
  } catch (e) {
    if (e) return e;
    return { error: "Unknown Error" };
  }
};

export default getCameras;
